import React from 'react';
import styles from './DriverDestinations.module.css';
import DoughnutSkeleton from 'components/Skeletons/DoughnutSkeleton';
import RectangleSkeleton from 'components/Skeletons/RectangleSkeleton';

export function DriverDestinationsSkeleton(): JSX.Element {
    return (
        <div className={styles.driverDestinationsContainer}>
            <DoughnutSkeleton />
            <div className={`${styles.destinationItemsContainer} ${styles.destinationItemsContainerSkeleton}`}>
                {Array.from({ length: 6 }).map((_, index) => (
                    <RectangleSkeleton key={index} />
                ))}
            </div>
        </div>
    );
}
